import { motion } from "framer-motion";

interface KarmaTextProps {
  show: boolean;
}

export const KarmaText = ({ show }: KarmaTextProps) => {
  if (!show) return null;

  return (
    <motion.div
      className="flex items-center justify-center overflow-visible"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.3, duration: 0.5 }}
    >
      <motion.div
        className="text-center overflow-visible"
        initial={{ scale: 0, rotate: -10 }}
        animate={{ scale: 1, rotate: 0 }}
        transition={{
          delay: 0.8,
          duration: 0.6,
          type: "spring",
          stiffness: 200,
          damping: 15,
        }}
      >
        <motion.h1
          className="text-5xl md:text-7xl font-black uppercase tracking-wider overflow-visible"
          style={{
            background:
              "linear-gradient(135deg, hsl(280, 100%, 80%) 0%, hsl(260, 100%, 65%) 50%, hsl(240, 80%, 55%) 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            filter:
              "drop-shadow(0 0 30px hsl(270, 100%, 60%)) drop-shadow(0 0 60px hsl(250, 80%, 50%))",
          }}
          animate={{
            textShadow: [
              "0 0 20px hsl(270, 100%, 60%)",
              "0 0 40px hsl(280, 100%, 70%)",
              "0 0 20px hsl(270, 100%, 60%)",
            ],
          }}
          transition={{
            duration: 1,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          KARMA
        </motion.h1>
        <motion.h2
          className="text-4xl md:text-6xl font-black uppercase tracking-widest mt-2 overflow-visible"
          style={{
            background:
              "linear-gradient(135deg, hsl(200, 100%, 75%) 0%, hsl(260, 100%, 70%) 50%, hsl(280, 80%, 60%) 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            filter:
              "drop-shadow(0 0 20px hsl(260, 100%, 60%)) drop-shadow(0 0 40px hsl(280, 80%, 50%))",
          }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.2, duration: 0.4 }}
        >
          EATEN
        </motion.h2>
      </motion.div>
    </motion.div>
  );
};
